import { SET_PAYROLL_DATA, SET_PAYROLL_ID, SET_PAYROLL_OPTIONS } from "constants/payrollConstants";

const initialState: any = {
  id: "",
  payroll: [],
  options: [],
};

const payrollReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PAYROLL_DATA:
      return {
        ...state,
        payroll: action.payroll,
      };
    case SET_PAYROLL_OPTIONS:
      return {
        ...state,
        options: action.options,
      };
    case SET_PAYROLL_ID:
      return {
        ...state,
        id: action.id,
      };

    default:
      return state;
  }
};

export default payrollReducer;
